import './index-administration-tab-content.style.scss'

class indexAdministrationTabContentController {

}

export default indexAdministrationTabContentController;



// WEBPACK FOOTER //
// ./ui/src/components/index-administration-tab-content/index-administration-tab-content.controller.js